// context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { apiFetch, setToken, getToken, clearToken } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // true while check the token

    // VERIFY TOKEN ON MOUNT
    useEffect(() => {
        const token = getToken();
        if (!token) {
            setLoading(false);
            return;
        }

        apiFetch("/api/auth/me")
            .then((data) => setUser(data.user))
            .catch(() => {
                clearToken();
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    // REGISTER
    const register = useCallback(async (username, email, password, turnstileToken) => {
        const data = await apiFetch("/api/auth/register", {
            method: "POST",
            body: JSON.stringify({ username, email, password, turnstileToken }),
        });
        setToken(data.token);
        setUser(data.user);
        return data;
    }, []);

    // LOGIN
    const login = useCallback(async (login, password) => {
        const data = await apiFetch("/api/auth/login", {
            method: "POST",
            body: JSON.stringify({ login, password }),
        });
        setToken(data.token);
        setUser(data.user);
        return data;
    }, []);

    // LOGOUT
    const logout = useCallback(() => {
        clearToken();
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, register }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}